import React from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import "../../styles/BaseWidget.css";

export function BaseWidget({
  title,
  subtitle,
  headerRight,
  accentColor,
  isLoading,
  error,
  className,
  children,
}) {
  const rootClass = "cp-widget" + (className ? " " + className : "");

  return (
    <div className={rootClass}>
      {accentColor && (
        <div
          className="cp-widget__accent"
          style={{ backgroundColor: accentColor }}
          aria-hidden="true"
        />
      )}

      <div className="cp-widget__body">
        <Row className="g-0 cp-widget__header align-items-center">
          <Col className="cp-widget__title-col">
            <h3 className="cp-widget__title">{title}</h3>
            {subtitle && <p className="cp-widget__subtitle">{subtitle}</p>}
          </Col>
          {headerRight && (
            <Col xs="auto" className="cp-widget__actions">
              {headerRight}
            </Col>
          )}
        </Row>

        <div className="cp-widget__content">
          {isLoading ? (
            <div className="cp-widget__state" role="status">
              <Spinner animation="border" size="sm" />
            </div>
          ) : error ? (
            <div
              className="cp-widget__state cp-widget__state--error"
              role="alert"
            >
              {error}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
}
